import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
  CartesianGrid,
} from "recharts";
import { CATEGORY_COLORS } from "../../lib/operatorWalk";

const axisFont = { fontFamily: "'Outfit', sans-serif", fontSize: 11, fill: "#94A3B8" };

function MiniTrend({ category, series }) {
  const color = CATEGORY_COLORS[category.key] || "#3B1E5A";
  return (
    <div className="bg-white border border-brand-200 p-5" data-testid={`trend-${category.key}`}>
      <div className="flex items-center justify-between mb-3">
        <h4 className="font-serif text-lg text-brand-700">{category.title}</h4>
        <span className="inline-block w-3 h-3" style={{ background: color }} aria-hidden />
      </div>
      <div style={{ height: 150 }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={series} margin={{ top: 6, right: 10, bottom: 0, left: -22 }}>
            <CartesianGrid stroke="#F1ECF9" vertical={false} />
            <XAxis dataKey="label" tick={axisFont} axisLine={false} tickLine={false} interval="preserveStartEnd" />
            <YAxis domain={[0, 100]} ticks={[0, 50, 100]} tick={axisFont} axisLine={false} tickLine={false} />
            <Tooltip
              formatter={(v) => [`${v}%`, category.title]}
              contentStyle={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, border: "1px solid #E5D4FF" }}
            />
            <Line
              type="monotone"
              dataKey={category.key}
              stroke={color}
              strokeWidth={2.5}
              dot={{ r: 3, fill: color }}
              activeDot={{ r: 5 }}
              isAnimationActive
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default function TrendCharts({ series, categories }) {
  if (!series || series.length === 0) {
    return (
      <div className="text-ink-muted text-sm" data-testid="trends-empty">
        Trend lines appear once you have more than one published report.
      </div>
    );
  }
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5" data-testid="trend-charts">
      {categories.map((cat) => (
        <MiniTrend key={cat.key} category={cat} series={series} />
      ))}
    </div>
  );
}
